<script>
export default {
    emits: ['toggle'],
    methods: {
        toggleSidebar() {
            this.$emit('toggle');
        }
    }
};
</script>

<template>
    <nord-button
        class="up-sidebar-toggle-button"
        variant="primary"
        square
        @click="toggleSidebar"
    >
        <nord-icon name="arrow-left-double" class="up-sidebar-toggle-button--icon"></nord-icon>
    </nord-button>
</template>

<style lang="scss" scoped>
.up-sidebar-toggle-button {
    --n-button-border-radius: var(--n-border-radius-circle);
    position: absolute;
    top: 92px;
    right: 4px;
    border-radius: 100px;
    --n-button-box-shadow: var(--n-box-shadow-card);

    &:hover {
        --n-button-box-shadow: none;
    }
}
</style>